// extracted by mini-css-extract-plugin
export default {"myInput__wrapper":"MyInput_myInput__wrapper__V-ZnF","myInput":"MyInput_myInput__GQPEi","myInputInvalid":"MyInput_myInputInvalid__hGlV4"};